import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "marginInlineStart", "variant"],
  _excluded2 = ["children", "marginInlineStart", "variant"];
import { Button as FoundationsButton } from 'foundations-components/transitional/components/Button';
import { ButtonContent } from './ButtonContent';
import { IconButton as FoundationsIconButton } from 'foundations-components/transitional/components/IconButton';
import { IconContainer } from '../Icons/IconContainer';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Button = _ref => {
  let {
      children,
      marginInlineStart = '0',
      variant = 'primary'
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(Object.assign({
    marginInlineStart
  }, restWithSpacingProps));
  return /*#__PURE__*/_jsx(FoundationsButton, Object.assign({}, rest, spacingProps, {
    use: variant,
    children: /*#__PURE__*/_jsx(ButtonContent, {
      children: children
    })
  }));
};
Button.Icon = props => /*#__PURE__*/_jsx(IconContainer, Object.assign({}, props));
export const ButtonIconOnly = _ref2 => {
  let {
      children,
      marginInlineStart = '0',
      variant
    } = _ref2,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(Object.assign({
    marginInlineStart
  }, restWithSpacingProps));
  return /*#__PURE__*/_jsx(FoundationsIconButton, Object.assign({}, rest, spacingProps, {
    use: variant,
    children: children
  }));
};
ButtonIconOnly.Icon = props => /*#__PURE__*/_jsx(IconContainer, Object.assign({}, props));